import React, { useEffect } from 'react';

import { getCart } from '../../services/cartService';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { hydrateCart } from '../../store/slices/cartSlice';

const CartBootstrap: React.FC = () => {
  const dispatch = useAppDispatch();
  const isHydrated = useAppSelector((state) => state.cart.isHydrated);

  useEffect(() => {
    if (isHydrated || typeof window === 'undefined') {
      return;
    }

    let frameId = 0;
    let timeoutId = 0;
    let idleId = 0;
    let cancelled = false;

    const hydrateFromStorage = () => {
      if (cancelled) {
        return;
      }

      dispatch(hydrateCart(getCart()));
    };

    frameId = window.requestAnimationFrame(() => {
      const idleWindow = window as Window &
        typeof globalThis & {
          requestIdleCallback?: (
            callback: IdleRequestCallback,
            options?: IdleRequestOptions
          ) => number;
          cancelIdleCallback?: (handle: number) => void;
        };

      if (typeof idleWindow.requestIdleCallback === 'function') {
        idleId = idleWindow.requestIdleCallback(hydrateFromStorage, { timeout: 450 });
        return;
      }

      timeoutId = window.setTimeout(hydrateFromStorage, 80);
    });

    return () => {
      cancelled = true;
      if (frameId) {
        window.cancelAnimationFrame(frameId);
      }
      if (timeoutId) {
        window.clearTimeout(timeoutId);
      }
      const idleWindow = window as Window &
        typeof globalThis & {
          cancelIdleCallback?: (handle: number) => void;
        };
      if (idleId && typeof idleWindow.cancelIdleCallback === 'function') {
        idleWindow.cancelIdleCallback(idleId);
      }
    };
  }, [dispatch, isHydrated]);

  return null;
};

export default CartBootstrap;
